import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { getUserDto } from '../../views/Activity/store/ActivitySelectors'
import YumInsufficientPermissions from './YumInsufficientPermissions'
import { getUserIntegrationScopes } from '../../common/auth/authSelectors'

const mapStateToProps = (state: IGlobalState, ownProps: any) => ({
  userDto: getUserDto(state),
  userIntegrationScopes: getUserIntegrationScopes(state),
  special: ownProps.special,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(YumInsufficientPermissions)
